var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoGauge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 132",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 112C24 55.67 72.35 18 132 18C191.65 18 240 55.67 240 112",
    fill: "none",
    stroke: "#DCF8E9",
    strokeLinecap: "round",
    strokeWidth: 22,
    pathLength: 100
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 112C24 55.67 72.35 18 132 18C191.65 18 240 55.67 240 112",
    fill: "none",
    stroke: "#20B961",
    strokeLinecap: "round",
    strokeWidth: 22,
    pathLength: 100,
    style: {
      strokeDasharray: "var(--score, 0) 100"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoGauge);
export default __webpack_public_path__ + "static/media/seo-gauge.d9e34b380d12a7bbed977a5f2ca54894.svg";
export { ForwardRef as ReactComponent };